<template>
  <div>
    <v-tooltip v-if="!isArchiving" location="bottom">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          :disabled="disabled"
          icon
          variant="text"
          @click="onArchiveWorkpackageClick"
        >
          <CommandItem icon="$archive-box" />
        </v-btn>
      </template>
      <span>{{ $t('actions.archive') }}</span>
    </v-tooltip>
    <v-progress-circular v-else indeterminate size="25" width="3" />
  </div>
</template>

<script>
import { capitalize } from 'lodash';
import { mapActions, mapState } from 'pinia';

// Stores
import { useSnackbarStore } from '@/stores/snackbar';
import { useBundlesStore } from '@/stores/bundles';
import { useWorkpackagesStore } from '@/stores/workpackages';
import { useContextStore } from '@/stores/context';

// Composables
import { usePermission } from '@/composables/use-permission';
import { useDayjs } from '@/composables/use-dayjs';

export default {
  props: {
    workpackage: {
      required: true,
      type: Object,
    },
    entity: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup() {
    const bundlesStore = useBundlesStore();
    const { canArchiveWorkpackage } = usePermission();
    const { dayjs } = useDayjs();

    return {
      bundlesStore,
      canArchiveWorkpackage,
      dayjs,
    };
  },
  data() {
    return {
      isArchiving: false,
      message: '',
      offset: null,
      pageSize: null,
    };
  },
  computed: {
    ...mapState(useWorkpackagesStore, ['archivedWorkpackagesCurrentPage', 'workpackages']),
    ...mapState(useContextStore, ['clientConfig']),
    disabled() {
      return !this.canArchiveWorkpackage;
    },
  },
  created() {
    this.message = this.$t(`notifications.archive${capitalize(this.entity)}`, {
      name: this.workpackage.name,
    });
    this.pageSize = this.clientConfig.archivedWorpackages.pageSize;
    this.offset = (this.archivedWorkpackagesCurrentPage - 1) * this.pageSize;
  },
  methods: {
    ...mapActions(useSnackbarStore, ['showSuccess']),
    async onArchiveWorkpackageClick() {
      this.isArchiving = true;
      const updates = {
        _id: this.workpackage._id,
        archived: true,
        archiveDate: this.dayjs.utc().toDate(),
      };
      await this.bundlesStore.updateBundle({
        bundleId: this.workpackage._id,
        updates,
      });
      await Promise.all([
        this.bundlesStore.fetchArchivedBundles({
          limit: this.pageSize,
          offset: this.offset,
        }),
      ]);

      this.bundlesStore.deleteBundleByIdMutation(this.workpackage._id);
      this.showSuccess(this.message);
    },
  },
};
</script>
